





















import { Component, Mixins, Prop } from "vue-property-decorator";
import { LineStyle, Color, LineKinds, PaintStyle, TextureKinds, TextStyle, TextAlignKinds } from "../../../../../../base/domain/drawing";
import { RectangleDragHandles } from "../../../../../../base/components/dragging";
import { ObjectKeys } from "../../../../../domain/configuration";
import { RectangleCoordinatableObjectDrawerBase } from "./base";
import { ConfiguredTextAreaDrawer } from "./drawers";

@Component({
  components: {
    ConfiguredTextAreaDrawer,
    RectangleDragHandles,
  },
})
export default class ImageRectangleCoordinatableObjectDrawer extends Mixins(RectangleCoordinatableObjectDrawerBase) {
  @Prop()
  displayName: string;

  @Prop()
  configurationKey: ObjectKeys;

  @Prop()
  imageStyle: any;

  get borderStyle(): LineStyle {
    return new LineStyle(new Color("#ff0000"), LineKinds.Normal, 1);
  }

  get paintStyle(): PaintStyle {
    return new PaintStyle(new Color("#ffff00"), TextureKinds.Fill);
  }

  get textStyle(): TextStyle {
    return new TextStyle(new Color("#ff0000"), TextAlignKinds.MiddleCenter, 12);
  }
}
